import { z } from 'zod';
import { dinheiro, taxa } from './primitives.js';
import type { ComposicaoPrecoResponse } from './precificacao.js';

/**
 * Onboarding (modo simples): previa de preco com os parametros digitados, SEM gravar nada.
 * Roda o motor (priceFormation) com um item sem tributos, uma despesa variavel total e condicao a vista.
 * Taxas em fracao (string decimal); o front converte o percentual digitado com `percentualParaTaxa`.
 */
export const previaOnboardingSchema = z.object({
  custo: dinheiro,
  despesaFixa: taxa,
  despesaVariavel: taxa,
  lucroDesejado: taxa,
  taxaFinanceira: taxa.default('0'),
});
export type PreviaOnboardingDto = z.infer<typeof previaOnboardingSchema>;

export interface PreviaOnboardingResponse {
  motorVersao: string;
  /** Saida de precisao cheia do motor (FormationResult). */
  resultado: unknown;
  warnings: unknown[];
  /** Equacao e composicao ja arredondadas para exibir (mesma da formacao). */
  composicao: ComposicaoPrecoResponse;
}

/**
 * GET /onboarding/status: o que a empresa ja tem para operar hoje. `operavel` = parametros vigentes + tabela ativa
 * com vigencia vigente + ao menos uma condicao ativa.
 */
export interface OnboardingStatusResponse {
  parametros: boolean;
  tabela: boolean;
  condicao: boolean;
  itens: number;
  operavel: boolean;
}

/**
 * GET /onboarding/checklist (Configuracoes > Onboarding): o que a empresa ja tem, passo a passo. So leitura; cada passo traz o link da tela onde fazer.
 * CENTROS e FICHAS so se aplicam a empresa de Industria ou Servico (o perfil de atividade decide).
 */
export type PassoOnboardingId = 'atividade' | 'parametros' | 'centros' | 'tabelas' | 'itens' | 'fichas' | 'usuarios';
export type StatusPassoOnboarding = 'CONCLUIDO' | 'FALTA' | 'NAO_SE_APLICA';
export interface PassoChecklistOnboarding {
  id: PassoOnboardingId;
  titulo: string;
  status: StatusPassoOnboarding;
  /** O que ja existe (contagens, sem R$). */
  contagens: Array<{ rotulo: string; valor: number }>;
  /** O que falta, em uma frase (vazio quando concluido ou nao se aplica). */
  detalhe: string;
  /** Tela onde fazer ou corrigir. */
  link: string;
}
export interface OnboardingChecklistResponse {
  empresaId: string;
  passos: PassoChecklistOnboarding[];
  /** Passos concluidos / passos que se aplicam a esta empresa. */
  concluidos: number;
  aplicaveis: number;
}
